import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { ROUTE } from "@/route/app_routes.js";

// Shared by both the login and register screens. Prefers real browser history (so it lands
// the user back on the exact page/scroll position they came from) but only when that history
// entry is actually one of our own pages -- an external referrer (e.g. a search engine) or a
// fresh tab/direct link falls back to the homepage instead of leaving the site.
const AuthBackButton = () => {
  const { t } = useTranslation("dashboard");
  const router = useRouter();

  const handleBack = () => {
    let cameFromSite = false;
    try {
      cameFromSite = Boolean(document.referrer) && new URL(document.referrer).origin === window.location.origin;
    } catch {
      cameFromSite = false;
    }

    if (cameFromSite && window.history.length > 1) {
      router.back();
    } else {
      router.push(ROUTE.home);
    }
  };

  return (
    <button type="button" className="rbt-auth-back-btn" onClick={handleBack} aria-label={t("authWrapper.backButton.ariaLabel", "Go back")}>
      <i className="feather-arrow-left"></i>
    </button>
  );
};

export default AuthBackButton;
